<template>
  <v-container pa-0>
    <v-alert :value="AlertNG.Alert" type="warning">{{AlertNG.Msg}}</v-alert>
  </v-container>
</template>

<script>
  export default {
    props: {
      AlertNG: {
        type: Object,
        default: {},
      },
    },
  }
</script>